import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";

import dictionary from "./dictionary/index";


export const defaultLocale = "en"

i18n
    .use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: dictionary,
        lng: defaultLocale,
        fallbackLng: defaultLocale,
        languages: ['en', 'it'],
        whitelist: ['en', 'it'],
        
        /*languages: ['en'],
        whitelist: ['en'],*/
        // useSuspense: false,

        interpolation: {
            // escapeValue: false // react already safes from xss
        },
        cleanCode: true,
        detection: {
            order: ['path'],
            lookupFromPathIndex: 1,
            checkWhitelist: true
        },
        debug: true
    });

// language change example
// i18n.changeLanguage('ru');

export default i18n;
